import { render, staticRenderFns } from "./openBankDetails.vue?vue&type=template&id=09fb49bc&scoped=true&"
import script from "./openBankDetails.vue?vue&type=script&lang=js&"
export * from "./openBankDetails.vue?vue&type=script&lang=js&"
import style0 from "./openBankDetails.vue?vue&type=style&index=0&id=09fb49bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fb49bc",
  null
  
)

export default component.exports